var _style, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKdaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000133520666977843457730000004461170672340490627_);}\n\t.st3{fill:#69009A;}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.4,
    cy: 441.1,
    r: 440.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.5284,
    y1: -1005.3211,
    x2: 553.7562,
    y2: -798.7242,
    gradientTransform: "matrix(1 0 0 1 0 1431.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA078C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69009A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.9,358.3l16.2,21c0,0,97.5,143.2,146.4,214.7c33.7,49.6,67.4,99.2,101.1,148.8c2.6,3.6,5,7.2,7.1,11.1 c-60,0.3-120.1,0.1-180.1,0.1c-59.8-88.7-178.4-266.7-178.4-266.7L356,468.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134947442194769529390000001374516302259425725_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.3484,
    y1: -1007.3731,
    x2: 578.6798,
    y2: -1187.6599,
    gradientTransform: "matrix(1 0 0 1 0 1431.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA078C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69009A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134947442194769529390000001374516302259425725_)"
    },
    d: "M313.6,541.8c-2.2,1.8-2,4.7-2,7.2 l-2.4,8.1l-11.7-187.8l14.3-15.3c3.7-2.5,145.7-152.6,214-224.1c1.6-2.3,4.5-1.6,6.9-1.8c59.5,0.2,178.4,0.1,178.4,0.1 S330.9,523.4,313.6,541.8z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.1,128.3h155.6v625.5H156.1V128.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdaIcon);
export default __webpack_public_path__ + "static/media/kda_icon.41b4b3267d7d36bfe8d8b524b5324f52.svg";
export { ForwardRef as ReactComponent };